// src/components/modals/CreateBucketModal.jsx
import React, { useState, useEffect } from "react";
import "./modals.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { BsInfoCircle } from "react-icons/bs";
import "bootstrap/dist/css/bootstrap.min.css";        // garante CSS carregado

/* ---------------- Tooltip reutilizável ---------------- */
const Info = ({ text }) => {
  const renderTooltip = (props) => (
    <Tooltip id={`tip-${text.slice(0, 6)}`} {...props}>
      {text}
    </Tooltip>
  );
  return (
    <OverlayTrigger
      placement="right"
      overlay={renderTooltip}
      container={document.body}
      trigger={["hover", "focus"]}
      popperConfig={{ strategy: "fixed" }}
      delay={{ show: 200, hide: 100 }}
    >
      <span className="ms-1" style={{ cursor: "help" }}>
        <BsInfoCircle className="text-secondary" aria-label="Informação" />
      </span>
    </OverlayTrigger>
  );
};

const CreateBucketModal = ({ isOpen, onClose, onCreate }) => {
  const [name, setName] = useState("");
  const [retentionEnabled, setRetentionEnabled] = useState(false);
  const [retentionDays, setRetentionDays] = useState("");
  const [isPublic, setIsPublic] = useState(0);
  const [versioning, setVersioning] = useState(false);

  useEffect(() => {
    document.body.classList.toggle("modal-open", isOpen);
    return () => document.body.classList.remove("modal-open");
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name.trim()) return;

    onCreate({
      name: name.trim(),
      retentionDays: retentionEnabled ? parseInt(retentionDays, 10) : null,
      isPublic,
      versioning: versioning ? 1 : 0,
    });

    setName("");
    setRetentionEnabled(false);
    setRetentionDays("");
    setIsPublic(0);
    setVersioning(false);
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        {/* Botão de fechar ------------------------------------------------ */}
        <button
          type="button"
          className="btn-close close-absolute"
          aria-label="Fechar"
          onClick={onClose}
        />

        <h3 className="mb-4">Criar Novo Bucket</h3>

        <form onSubmit={handleSubmit}>
          {/* Nome -------------------------------------------------- */}
          <div className="mb-3">
            <label htmlFor="bucketName" className="form-label">
              Nome do Bucket
            </label>
            <input
              id="bucketName"
              className="form-control"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          {/* Retenção --------------------------------------------- */}
          <div className="form-check form-switch mb-3">
            <input
              id="retentionSwitch"
              type="checkbox"
              className="form-check-input"
              checked={retentionEnabled}
              onChange={() => setRetentionEnabled((v) => !v)}
            />
            <label className="form-check-label" htmlFor="retentionSwitch">
              Ativar retenção?
              <Info text="Impede exclusão antes do prazo; garante conformidade e proteção contra deleções acidentais." />
            </label>
          </div>

          {retentionEnabled && (
            <div className="mb-3">
              <label htmlFor="retentionDays" className="form-label">
                Dias de retenção
              </label>
              <input
                id="retentionDays"
                type="number"
                className="form-control"
                min="1"
                value={retentionDays}
                onChange={(e) => setRetentionDays(e.target.value)}
              />
            </div>
          )}

          {/* Visibilidade ----------------------------------------- */}
          <div className="mb-3">
            <label className="form-label d-block">
              Visibilidade
              <Info text="Privado: acesso só para usuários autenticados. Público: qualquer pessoa com o link pode ler." />
            </label>

            <div className="btn-group" role="group">
              <input
                type="radio"
                id="visPrivate"
                name="visibility"
                className="btn-check"
                checked={isPublic === 0}
                onChange={() => setIsPublic(0)}
              />
              <label className="btn btn-outline-secondary" htmlFor="visPrivate">
                Privado
              </label>

              <input
                type="radio"
                id="visPublic"
                name="visibility"
                className="btn-check"
                checked={isPublic === 1}
                onChange={() => setIsPublic(1)}
              />
              <label className="btn btn-outline-secondary" htmlFor="visPublic">
                Público
              </label>
            </div>
          </div>

          {/* Versionamento ---------------------------------------- */}
          <div className="form-check form-switch mb-4">
            <input
              id="versioningSwitch"
              type="checkbox"
              className="form-check-input"
              checked={versioning}
              onChange={() => setVersioning((v) => !v)}
            />
            <label className="form-check-label" htmlFor="versioningSwitch">
              Ativar versionamento
              <Info text="Mantém todas as versões dos objetos; permite restaurar conteúdo antigo ou sobrescrito." />
            </label>
          </div>

          {/* Botões ---------------------------------------------- */}
          <div className="d-flex justify-content-end">
            <button
              type="button"
              className="btn btn-secondary me-2"
              onClick={onClose}
            >
              Cancelar
            </button>
            <button type="submit" className="btn btn-primary">
              Criar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateBucketModal;
